export const CERTIFICATION_ISSUER_LIST_QUERY_KEY = ["certification-issuers", "list"] as const;

export const getCertificationIssuerListQueryKey = (parameters: unknown) => [
    ...CERTIFICATION_ISSUER_LIST_QUERY_KEY,
    parameters,
];
